// extracted by mini-css-extract-plugin
export default {"contentPage":"CustomePage_contentPage__r2QNU"};